import Toggle from '../../../pages/settings/components/Toggle';
import { useProject } from '../../../contexts/ProjectContext';
import { dashboardService } from '../../../services/dashboard';

function SettingRow({ title, description, checked, onChange }) {
  return (
    <div className="rounded-xl border border-theme-secondary bg-theme-main p-4 flex items-center justify-between gap-4">
      <div className="min-w-0">
        <div className="font-medium text-sm">{title}</div>
        {description && <p className="text-sm opacity-60 mt-0.5">{description}</p>}
      </div>
      <Toggle checked={checked} onChange={onChange} label={title} />
    </div>
  );
}

export default function ProjectStep() {
  const { projects, selectedHash, setSelectedProject, reloadProjects } = useProject();
  const project = projects.find((p) => p.hash === selectedHash) || projects[0] || null;

  const patchProject = (patch) => {
    if (!project) return;
    dashboardService.patchProject(project.hash, patch, reloadProjects, console.error);
  };

  if (!project) {
    return (
      <div className="rounded-2xl border border-dashed border-theme-secondary p-12 text-center opacity-60">
        <p>No projects yet. Create one in Settings first.</p>
      </div>
    );
  }

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-2">Configure your project</h1>
      <p className="text-sm opacity-60 mb-8">
        Choose a project and enable the features you want for routing traffic.
      </p>

      <label className="block text-sm font-medium opacity-70 mb-2">Project</label>
      <select
        value={selectedHash || ''}
        onChange={(e) => setSelectedProject(e.target.value)}
        className="w-full rounded-xl border border-theme-secondary bg-theme-main px-4 py-3 text-sm mb-8"
      >
        {projects.map((p) => (
          <option key={p.hash} value={p.hash}>{p.name}</option>
        ))}
      </select>

      <div className="space-y-3">
        <SettingRow
          title="Routing"
          description="Route traffic to open-source models. When off, requests pass through to your provider."
          checked={project.routing_enabled !== false}
          onChange={(on) => patchProject({ routing_enabled: on })}
        />
        <SettingRow
          title="Cache"
          description="Store routed request and response payloads for faster repeats."
          checked={!!project.cache_enabled}
          onChange={(on) => patchProject({ cache_enabled: on })}
        />
        <SettingRow
          title="Shadow evals"
          description="Sample production traffic and score model quality in the background."
          checked={!!project.eval_enabled}
          onChange={(on) => patchProject({ eval_enabled: on })}
        />
      </div>
    </div>
  );
}
